import { useEffect, useRef, useState } from 'react';

/**
 * Registra UNA impresión por carga de la página de impresión y devuelve si es copia/reimpresión.
 * El ref evita el doble POST que provoca StrictMode en desarrollo (marcaría la primera impresión como COPIA).
 */
export function useRegistroImpresion(id: string | undefined, registrar: (id: string) => Promise<boolean>): boolean | null {
  const [copia, setCopia] = useState<boolean | null>(null);
  const hecho = useRef<string | null>(null);
  useEffect(() => {
    if (!id || hecho.current === id) return;
    hecho.current = id;
    registrar(id).then(setCopia).catch(() => setCopia(false));
  }, [id, registrar]);
  return copia;
}
